import PropTypes from "prop-types";
import { ActionIcon, Menu, Tooltip } from "@mantine/core";
import { HiEllipsisVertical } from "react-icons/hi2";

function TableRowActionsMenu({ items = [], position = "bottom-end" }) {
  return (
    <Menu position={position} shadow="md" width={180} withinPortal>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="dark"
          size="sm"
          onClick={(e) => e.stopPropagation()}
          aria-label="Row actions"
        >
          <HiEllipsisVertical size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {items.map((item) => {
          const menuItem = (
            <Menu.Item
              key={item.label}
              leftSection={item.icon}
              disabled={item.disabled}
              color={item.color}
              onClick={(e) => {
                e.stopPropagation();
                item.onClick?.();
              }}
            >
              {item.label}
            </Menu.Item>
          );

          return item.disabled && item.disabledReason ? (
            <Tooltip
              key={item.label}
              label={item.disabledReason}
              position="left"
              withArrow
            >
              <div>{menuItem}</div>
            </Tooltip>
          ) : (
            menuItem
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}

TableRowActionsMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      disabledReason: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  position: PropTypes.string,
};

export default TableRowActionsMenu;
